import { useMemo } from "react";
/**
 * Hook to determine track color based on bubble class
 */
export const useTrackColor = (bubbleClassName) => {
  return useMemo(() => {
    if (bubbleClassName.includes("purple")) {
      return "var(--e-global-color-secondary)";
    }
    if (bubbleClassName.includes("blue")) {
      return "var(--e-global-color-primary)";
    }
    return "#002e5f";
  }, [bubbleClassName]);
};
